import { ApplicationSetting } from '@era/settings-sdk';

import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export type CategoryType =
  | 'Brand'
  | 'Location'
  | 'Room'
  | 'Bar'
  | 'FrontDesk'
  | 'Housekeeping'
  | 'Kiosk'
  | 'Staff'
  | 'None';

export interface CategoryApplicationSetting extends ApplicationSetting {
  categoryType: CategoryType;
  categoryId: string;
  bundleIdentifier: string;
}

export function selectSettingIdFromSetting(setting: CategoryApplicationSetting) {
  return setting.categoryType + setting.categoryId + setting.bundleIdentifier + setting.key;
}

export const adapter: EntityAdapter<CategoryApplicationSetting> = createEntityAdapter<CategoryApplicationSetting>({
  selectId: selectSettingIdFromSetting,
});

export type CategoryApplicationSettingState = EntityState<CategoryApplicationSetting>;

export const initialState: CategoryApplicationSettingState = adapter.getInitialState();
